/**
  Copyright (c) [2022]
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

// Vue Imports
import { defineComponent } from 'vue';
// Router Imports
import router from '@/router';

// Defining Component
export default defineComponent({
  components: {},
  props: {},
  data() {
    return {}
  },
  watch: {},
  computed: {
    currentUser() {
      const user = localStorage.getItem('user');

      if (user) {
        const parseduser = JSON.parse(user);
        return parseduser;
      }

      return {}
    },
    navigateToLogin() {
      localStorage.removeItem('user')
      setTimeout(() => {
        router.push('/');
      }, 500);
    },
    navigateToEvents() {
      router.push('/events');
    },
    currentUserPicure() {
      const user = localStorage.getItem('user');

      if (user) {
        const parseduser = JSON.parse(user);
        return 'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' + parseduser.profilePicture;
      }

      return null
    }
  },
  mounted() {
    document.addEventListener('click', function handleClickOutsideBox(event: any) {
      if (event.target.id.startsWith('nav-menu-') ||  event.target.id === 'user-menu-0' || event.target.id === 'user-menu' || event.target.id === 'user-menu1' || event.target.id === 'user-menu2' || event.target.id === 'user-menu3') {
        const item: any = document.getElementById('nav-menu');
        item.style.display = '';
      } else {
        const item: any = document.getElementById('nav-menu');
        item.style.display = 'none';
      }
    });
  }
});
